<script>
import { mapGetters } from 'vuex';
import { DEFAULT_SITE_LOGO } from '@/helpers/siteLogo';
import { onSiteLogoImgError } from '@/helpers/imageFallback';

export default {
  name: 'SiteLogoImg',
  inheritAttrs: false,
  props: {
    alt: {
      type: String,
      default: 'RRPL — Reis do Rompimento Primeira Liga',
    },
  },
  computed: {
    ...mapGetters('siteBranding', ['siteLogoUrl']),
    imgSrc() {
      return this.siteLogoUrl || DEFAULT_SITE_LOGO;
    },
  },
  methods: {
    onLogoError: onSiteLogoImgError,
  },
};
</script>

<template>
  <img :src="imgSrc" :alt="alt" v-bind="$attrs" @error="onLogoError" />
</template>
